import { render, staticRenderFns } from "./BindsTableRow.vue?vue&type=template&id=41e22878&"
import script from "./BindsTableRow.vue?vue&type=script&lang=js&"
export * from "./BindsTableRow.vue?vue&type=script&lang=js&"
import style0 from "./BindsTableRow.vue?vue&type=style&index=0&id=41e22878&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports